module.exports = __webpack_public_path__ + "static/media/vip_room_2.575df0ee.png";